import { memo, useCallback } from "react"

import { ColorPickerPopover, type ColorPickerPopoverProps } from "../../../components/Popovers/ColorPickerPopover"
import { useFallbackEditor, useHighlightState } from "../../hooks"
import type { OptionalEditorProps } from "../typings"

interface TextHighlightDropdownMenuProps
	extends Omit<ColorPickerPopoverProps, "color" | "onColorChange" | "required">, OptionalEditorProps {}

export const TextHighlightPickerPopover = memo<TextHighlightDropdownMenuProps>((props) => {
	const { children, editor: editorFromProps, ...rest } = props

	const editor = useFallbackEditor(editorFromProps)
	const state = useHighlightState(editor)

	const handleColorChange = useCallback(
		(color: string | undefined) => {
			if (color) {
				editor.chain().focus().toggleHighlight({ color }).run()
			} else {
				editor.chain().focus().unsetHighlight().run()
			}
		},
		[editor],
	)

	return (
		<ColorPickerPopover required={false} color={state?.color} onColorChange={handleColorChange} {...rest}>
			{children}
		</ColorPickerPopover>
	)
})
TextHighlightPickerPopover.displayName = "TextHighlightDropdownMenu"
